<template>
    <div class="shop-info-dialog">
        <el-dialog title="二维码生成成功，请先选择下单SKU，再查看二维码！" :visible.sync="dialog" width="520px" :close-on-click-modal="true" top="50px">
            <div class="text-center" v-if="shopInfo">
                <el-form class="flex-3" :model="form" label-width="100px">
                    <div v-if="shopInfo.title" class="">
                        <el-form-item label-width="0px">
                            <div class="flex">
                                <el-image :src="shopInfo.thumb[0]" fit="contain" class="goodImage" />
                                <div class="fc-666 info">{{ shopInfo.title }}</div>
                            </div>
                        </el-form-item>
                    </div>
                    <div v-if="shopInfo.skus && shopInfo.skus.length > 0">
                        <p style="margin-bottom: 10px; text-align: left; font-size: 16px; font-weight: 600;">商品规格: </p>
                        <el-form-item label-width="0px">
                            <div style="height: 300px; overflow: scroll;">
                                <el-radio-group v-model="radio">
                                    <el-radio v-for="(item, index) in shopInfo.skus" :key="index" :label="item.skuId">{{ item.skuName }}</el-radio>
                                </el-radio-group>
                            </div>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer text-center">
                <el-button class="width-100 footer-btn" type="primary" :loading="subLoading" @click="handleSubmit">确定并查看二维码</el-button>
            </div>
        </el-dialog>
        <qr-code-dialog v-if="qrCodeDialog.show" v-model="qrCodeDialog.show" :ex-data="qrCodeDialog.exData"></qr-code-dialog>
    </div>
</template>

<script>
import QrCodeDialog from "./QrCodeDialog"
export default {
    components: {
        QrCodeDialog
    },
    props: {
        value: {
            type: Boolean,
            default: true
        },
        exData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    data() {
        return {
            dialog: !!this.value,
            subLoading: false,
            radio: undefined,
            shopInfo: null,
            form: {},
            qrCodeDialog: {
                show: false,
                exData: true,
            },
        }
    },
    mounted() {
        let { shopInfo } = this.exData
        this.shopInfo = shopInfo
        if (shopInfo.skus && shopInfo.skus.length > 0) {
            this.radio = shopInfo.skus[0].skuId
        }
    },
    methods: {
        async handleSubmit() {
            this.subLoading = true
            let url = this.exData.activeMarking === 'senior' ? '/tool/accounts/no-trace-supplement-senior-web' : '/tool/accounts/no-trace-supplement-ordinary-web'
            const staForm = this.exData.isStable === 'stable' ? {stable: 1} : {}
            const data = await this.$fetch(url, {
                ...staForm,
                count: this.exData.count,
                tag: this.exData.tag,
                account: this.exData.account,
                product_id: this.exData.product_id,
                sku_id: this.radio,
                product_title: this.shopInfo.title,
                log_id: this.exData.log_id,
                sku_name: this.shopInfo.skus && this.shopInfo.skus.length > 0 ? this.shopInfo.skus.find(item => item.skuId === this.radio).skuName : '',
            }, 'post')
            this.subLoading = false
            if (+data.code === 0) {
                await this.$emit("success", data.data.url)
                this.dialog = false;
            }
        }
    },
    watch: {
        dialog(val) {
            if (!val) this.$emit('input', val)
        }
    }
}
</script>

<style lang="scss">
.shop-info-dialog {
    .el-radio-group {
        display: flex;
        flex-wrap: wrap;
        text-align: left;
        .el-radio {
            width: 100%;
        }
    }
}

</style>

<style lang="scss" scoped>
.el-radio {
    margin-bottom: 10px;
}
.goodImage {
    width: 80px;
    height: 80px;
    margin-right: 15px;
    flex-basis: 80px;
}
.info {
    line-height: 20px;
    flex-basis: 80%;
}
</style>
